<!-- <div class="row pt-3" *ngIf="Questionlistresponse">
  <div class="col-12">
    <div class="scroll-style border">
      <div class="d-flex border-bottom">
        <div class="px-1 text-left Rl-hdr">No.</div>
        <div class="px-1 text-left Rl-hdr">
          <p class="Rl-col-1">Question</p>
        </div>
        <div class="px-1 text-left Rl-hdr">
          <p class="Rl-col-1">Translated Question</p>
        </div>
        <div class="px-1 text-left Rl-hdr">
          <p class="Rl-col-2">Question Status</p>
        </div>
        <div class="px-1 text-left Rl-hdr">
          <p class="Rl-col-1">Question</p>
        </div>
        <div class="px-1 text-left Rl-hdr">
          <p class="Rl-col-1">Allow Translate</p>
        </div>
        <div class="px-1 text-left Rl-hdr">
          <p class="Rl-col-1">Entered By</p>
        </div>
        <div class="px-1 text-left Rl-hdr">
          <p class="Rl-col-1">Entered Date</p>
        </div>
        <div class="px-1 text-left Rl-hdr">
          <p class="Rl-col-1">Reviewed By</p>
        </div>
        <div class="px-1 text-left Rl-hdr">
          <p class="Rl-col-1">Reviewed Date</p>
        </div>

      </div>

      <div class="d-flex invRow"
        *ngFor="let s of Questionlistresponse; let i = index">
        <div class="px-2 text-right pt-1 pb-1  border-bottom">{{i+1}}</div>
        <div class="px-1 text-left pt-1 pb-1 border-bottom" (click)="EditQuestion(s)">
           <p class="Rl-col-1 link">{{s.Question_Id}}</p>

        </div>
        <div class="px-1 text-left pt-1 pb-1 border-bottom">
          <p class="Rl-col-1">{{s.Translated_Question_Id}}</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 border-bottom">
          <p class="Rl-col-2">{{s.Question_Status_Type_Name}}</p>
        </div>

        <div class="px-1 text-left pt-1 pb-1 border-bottom">
          <p class="Rl-col-1">{{s.Allow_Translation_Ind}}</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 border-bottom">
          <p class="Rl-col-1">{{s.Created_By}}</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 border-bottom">
          <p class="Rl-col-1">{{s.Creation_Date | date: "dd-MMM-yyyy"}}</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 border-bottom">
          <p class="Rl-col-1">{{s.Created_By}}</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 border-bottom">
          <p class="Rl-col-1">{{s.Creation_Date | date: "dd-MMM-yyyy"}}</p>
        </div>
        </div>
      </div>

      <div class="d-flex" *ngIf="!Questionlistresponse">
        <div class="p-3 m-3">No search results</div>
      </div>

    </div>
  </div> -->
  <div class="row pt-1" *ngIf="Questionlistresponse">
    <div class="col-12">
      <!-- <div class="table-responsive" style="overflow: scroll;min-height: 75vh !important;max-height:  60vh;height: 60vh;margin-right:2px;">
      <table class="table table-sm table-bordered table-hover">
        <thead>
          <tr class="table-active">
            <th class="col-md-1 centertext">Question No.</th>
            <th class="col-md-1 centertext">Translated Question#</th>
            <th class="col-md-1 centertext">Status</th>
            <th class="col-md-4 centertext">Question</th>
            <th class="col-md-1 centertext">Allow Translate</th>
            <th class="col-md-1 centertext">Created By</th>
            <th class="col-md-1 centertext">Creation Date</th>
            <th class="col-md-1 centertext">Reviewed By</th>
            <th class="col-md-1 centertext">Reviewed Date</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let s of Questionlistresponse;let i=index" (click)="EditQuestion(s)">
            <td class='link' >{{s.Question_Id}}</td>
            <td>{{s.Translated_Question_Id}}</td>
            <td class="centertext">{{s.Question_Status_Type_Name}}</td>
            <td ><div [innerHtml]="s.Question_Text"></div></td>
            <td class="centertext">{{s.Allow_Translation_Ind}}</td>
            <td class="centertext">{{s.Created_By}}</td>
            <td class="centertext">{{s.Creation_Date | date: "dd/MM/yy" }}</td>
            <td class="centertext">{{s.Created_By}}</td>
            <td class="centertext">{{s.Creation_Date | date: "dd/MM/yy" }}</td>

          </tr>
        </tbody>
      </table>
    </div> -->
    <app-tinyedneditor [ngClass]="{ 'd-none': ScreenName1 === 'editquestion' }" [Questionlistresponse]="Questionlistresponse" (EditQuestion)="EditQuestion($event)"></app-tinyedneditor>
</div>
</div>
<!-- EDIT MODAL START -->
  <div class="modal fade  show Model_popup1" style="z-index:1090" *ngIf="EditQuestionFlag">
    <div class="modal-dialog modal-dialog-centered modal-dialog-Question-add">
      <div class="modal-content">
        <div class="modal-header border Page-Header p-1 py-0">
          <h6 class="HeadContent" id="QuestionTemplatetitle">Edit Question</h6>
          <button type="button" class="close"
          (click)="Editpopup()" style="padding-right: 20px;font-size: 30px;outline: 0;">
            <span aria-hidden="true">&times;</span></button>
        </div>
        <div class="modal-body px-3 py-0">
          <app-question-add-edit
          [questionsubjectresponse]="questionsubjectresponse"
          [ScreenName1]="ScreenName1"
          [redirect]="redirect"
          [selectedQuestionList]="selectedQuestionList"
          [EditQuestionFlag]="EditQuestionFlag"
          [selectedQuestionById]="selectedQuestionById"
          [subjectById]="subjectById"
          (ClickQuestionStatusPopup)="ClickQuestionStatusPopup($event)"
          (ClickQuestionstatus)="ClickQuestionstatus($event)"
          (ClickQuestionBody)="ClickQuestionBody($event)"
          (EmitAnswerChoiceDetails)="EmitAnswerChoiceDetails($event)"
          (EmitpreviewDetails)="EmitpreviewDetails($event)"
          (CloseEditQuestion)="CloseEditQuestion($event)"
          (EditAnswerNote)="EditAnswerNote($event)"
          (EditSolutionHint)="EditSolutionHint($event)"
          (ClickAnswerChoice)="ClickAnswerChoice($event)"
          (ClickQuestionPreview)="ClickQuestionPreview($event)"
          (Refreshlist)="Refreshlist($event)"
          ></app-question-add-edit>

        </div>
      </div>
    </div>
    <!-- (ClickAnswerChoice)="ClickAnswerChoice($event)"

            (ClickQuestionPreview)="ClickQuestionPreview($event)"
             [EditQuestionFlag]="EditQuestionFlag"
           (CloseEditQuestion)="CloseEditQuestion($event)"
           (EditAnswerNote)="EditAnswerNote($event)" -->
  </div>
<!-- EDIT MODAL END -->

<!-- ADD/EDIT QUESTION START -->
  <div class="modal fade  show Model_popup1" style="z-index:1090" *ngIf="EditQuestionBodyPopup">
    <div class="modal-dialog modal-dialog-centered modal-dialog-Question-add">
      <div class="modal-content">
        <div class="modal-header border Page-Header p-1 py-0">
          <h6 class="HeadContent" id="QuestionTemplatetitle">Add/Edit Question</h6>
          <button type="button" class="close"
            (click)="ReturnEdit()" style="padding-right: 20px;font-size: 30px;outline: 0;">
            <span aria-hidden="true">&times;</span></button>
        </div>

        <div class="modal-body px-3 py-0">
          <app-question-body-add-edit (Returnpreview)="Returnpreview($event)" (Questionrefreshpreview)="Questionrefreshpreview($event)" (REdirectPreview)="REdirectPreview($event)" (REdirecttoRightAnswer)="REdirecttoRightAnswer($event)" [selectedQuestionList]="selectedQuestionList" [subjectById]="subjectById" [selectedQuestionById]="selectedQuestionById" [EditQuestionBodyPopup]="EditQuestionBodyPopup" (EditQuestionBodyclose)="EditQuestionBodyclose($event)"></app-question-body-add-edit>

        </div>
      </div>
    </div>
  </div>
<!-- ADD/EDIT QUESTION END -->

<!-- ADD EDIT ANSWER START -->
  <div class="modal fade  show Model_popup1"  style="z-index:1090" *ngIf="EditAnswerChoicePopup">
    <div class="modal-dialog modal-dialog-centered modal-dialog-Question-add">
      <div class="modal-content">
        <div class="modal-header border Page-Header p-1 py-0">
          <h6 class="HeadContent" id="QuestionTemplatetitle">Add/Edit Answer</h6>
          <button type="button" class="close"
            (click)="ReturnAnswerEdit()" style="padding-right: 20px;font-size: 30px;outline: 0;">
            <span aria-hidden="true">&times;</span></button>
        </div>

        <div class="modal-body px-3 py-0">
          <app-answer-choice-add-edit (Returnpreview)="Returnpreview($event)" (returnfromanswer)='returnfromanswer($event)' [Screenname]='Screenname' (RefreshPreviewAnswer)="RefreshPreviewAnswer($event)" (AnswerRedirectPreview)="AnswerRedirectPreview($event)" (EditSolutionHint1)="EditSolutionHint1($event)" (EditAnswerChoiceNoteBody)="EditAnswerChoiceNoteBody($event)" (EditAnswerchoiceclose)="EditAnswerchoiceclose($event)" [subjectById]="subjectById" [Answerflag]="Answerflag" [selectedQuestionById]="selectedQuestionById"></app-answer-choice-add-edit>
        </div>
      </div>
    </div>
  </div>
<!-- ADD EDIT ANSWER END -->

<!-- ADD EDIT ANSWER NOTE START -->

  <div class="modal fade  show Model_popup1" style="z-index:1090" *ngIf="AnswerChoiceNotePopup1">
    <div class="modal-dialog modal-dialog-centered modal-dialog-Question-add">
      <div class="modal-content">
        <div class="modal-header border Page-Header p-1 py-0">
          <h6 class="HeadContent" id="QuestionTemplatetitle">Add/Edit Answer Note</h6>
          <button type="button" class="close" (click)="ReturnAnswerNote()"
            style="padding-right: 20px;font-size: 30px;outline: 0;">
            <span aria-hidden="true">&times;</span></button>
        </div>

        <div class="modal-body px-3 py-0">
          <app-answer-choice-note (REdirecttoRightAnswerfromnote)="REdirecttoRightAnswerfromnote($event)" (EditAnswerchoiceNoteclose)="EditAnswerchoiceNoteclose($event)" [AnswerChoiceNotePopup1]="AnswerChoiceNotePopup1" [selectedQuestionById]="selectedQuestionById"></app-answer-choice-note>

        </div>
      </div>
    </div>
  </div>
<!-- ADD EDIT ANSWER NOTE END -->
 <!-- ADD EDIT SOLUTION HINT -->
  <div class="modal fade  show Model_popup1" style="z-index:1090" *ngIf="SolutionHintPopup">
    <div class="modal-dialog modal-dialog-centered modal-dialog-Question-add">
      <div class="modal-content">
        <div class="modal-header border Page-Header p-1 py-0">
          <h6 class="HeadContent" id="QuestionTemplatetitle">Add/Edit Solution Hint</h6>
          <button type="button" class="close" (click)="ReturnSolutionHint()"
            style="padding-right: 20px;font-size: 30px;outline: 0;">
            <span aria-hidden="true">&times;</span></button>
        </div>

        <div class="modal-body px-3 py-0">
          <!-- <app-answer-choice-note (EditAnswerchoiceNoteclose)="EditAnswerchoiceNoteclose($event)" [AnswerChoiceNotePopup1]="AnswerChoiceNotePopup1" [selectedQuestionById]="selectedQuestionById"></app-answer-choice-note> -->
          <app-answer-choice-solution-hint (REdirecttoRightAnswerfromnote)="REdirecttoRightAnswerfromnote($event)" (EditAnswerchoiceNoteclose11)="EditAnswerchoiceNoteclose11($event)" [selectedQuestionById]="selectedQuestionById"></app-answer-choice-solution-hint>
        </div>
      </div>
    </div>
  </div>
  <!-- ADD EDIT SOLUTION HINT END -->
   <!-- ADD EDIT ANSWER NOTE 2 -->
  <div class="modal fade  show Model_popup1" style="z-index:1090" *ngIf="EditAnswerChoiceNotePopup1">
    <div class="modal-dialog modal-dialog-centered modal-dialog-Question-add">
      <div class="modal-content">
        <div class="modal-header border Page-Header p-1 py-0">
          <h6 class="HeadContent" id="QuestionTemplatetitle">Add/Edit Answer Note</h6>
          <button type="button" class="close" (click)="ReturnAnswerNote1()"
            style="padding-right: 20px;font-size: 30px;outline: 0;">
            <span aria-hidden="true">&times;</span></button>
        </div>

        <div class="modal-body px-3 py-0">
          <app-answer-choice-note  (EditAnswerchoiceNoteclose1)="EditAnswerchoiceNoteclose1($event)" [EditAnswerChoiceNotePopup1]="EditAnswerChoiceNotePopup1" [selectedQuestionById]="selectedQuestionById"></app-answer-choice-note>

        </div>
      </div>
    </div>
  </div>
  <!-- ADD EDIT ANSWER NOTE 3 -->
  <div class="modal fade  show Model_popup1" style="z-index:1090" *ngIf="EditSolutionHintBodyPopup">
    <div class="modal-dialog modal-dialog-centered modal-dialog-Question-add">
      <div class="modal-content">
        <div class="modal-header border Page-Header p-1 py-0">
          <h6 class="HeadContent" id="QuestionTemplatetitle">Add/Edit Solution Hint</h6>
          <button type="button" class="close" (click)="ReturnEditSolutionHint()"
            style="padding-right: 20px;font-size: 30px;outline: 0;">
            <span aria-hidden="true">&times;</span></button>
        </div>

        <div class="modal-body px-3 py-0">
          <app-answer-choice-solution-hint  (EditAnswerchoiceNoteclose12)="EditAnswerchoiceNoteclose12($event)" [EditSolutionHintBodyPopup]="EditSolutionHintBodyPopup" [selectedQuestionById]="selectedQuestionById"></app-answer-choice-solution-hint>

        </div>
      </div>
    </div>
  </div>
  <!-- ADD EDIT ANSWER NOTE 3 END -->

  <div class="modal fade  show Model_popup1" style="z-index:1090" *ngIf="Questionpreviewpopupflag">
    <div class="modal-dialog modal-dialog-centered modal-dialog-Question-add">
      <div class="modal-content">
        <div class="modal-header border Page-Header p-1 py-0">
          <h6 class="HeadContent" id="QuestionTemplatetitle">Question preview</h6>
          <button type="button" class="close" (click)="ReturnQuestionpreview($event)"
            style="padding-right: 20px;font-size: 30px;outline: 0;">
            <span aria-hidden="true">&times;</span></button>
        </div>

        <div class="modal-body px-3 py-0">
          <app-question-preview
          [redirectscreenname]='redirectscreenname'
          (ReturnQuestionpreview)="ReturnQuestionpreview($event)"
           [previewdetail]="previewdetail"
           (EmitpreviewtoQuestion)="EmitpreviewtoQuestion($event)"
           (EmitpreviewtoAnswerChoice)="EmitpreviewtoAnswerChoice($event)"
           (EmitpreviewtoAnswerChoiceNote)="EmitpreviewtoAnswerChoiceNote($event)"
           (EmitpreviewtoSolutionHint)="EmitpreviewtoSolutionHint($event)"
           ></app-question-preview>

        </div>
      </div>
    </div>
  </div>
  
  <div class="modal fade  show Model_popup1" style="z-index:1090" *ngIf="Questionreviewpopupflag">
    <div class="modal-dialog modal-dialog-centered modal-dialog-Edit">
      <div class="modal-content">
        <div class="modal-header border Page-Header p-1 py-0">
          <h6 class="HeadContent" id="QuestionTemplatetitle">Review {{Questionstatus}} Question</h6>
          <button type="button" class="close" (click)="ReturnQuestionreview()"
            style="padding-right: 20px;font-size: 30px;outline: 0;">
            <span aria-hidden="true">&times;</span></button>
        </div>

        <div class="modal-body px-3 py-0">
          <app-question-submit-for-review
           (ReturnQuestionreviewclose)="ReturnQuestionreviewclose($event)"
            (Questionreviewclose)="Questionreviewclose($event)"
             (CloseEditQuestion)="CloseEditQuestion($event)"
              [EditQuestionFlag]="EditQuestionFlag"
               [Questionstatus]="Questionstatus"
                [selectedQuestionById]="selectedQuestionById"
                 [subjectById]="subjectById">

          </app-question-submit-for-review>

        </div>
      </div>
    </div>
  </div>
  <div class="modal fade  show Model_popup1" style="z-index:1090" *ngIf="QuestionStatuspopupflag">
    <div class="modal-dialog modal-dialog-centered modal-dialog-Edit2">
      <div class="modal-content">
        <div class="modal-header border Page-Header p-1 py-0">
          <h6 class="HeadContent" id="QuestionTemplatetitle">Question Status Changes History</h6>
          <button type="button" class="close" (click)="ReturnQuestionStatushistory($event)"
            style="padding-right: 20px;font-size: 30px;outline: 0;">
            <span aria-hidden="true">&times;</span></button>
        </div>

        <div class="modal-body px-3 py-0">
          <app-questionstatus-history (ReturnQuestionStatushistory)="ReturnQuestionStatushistory($event)" [selectedQuestionById]="selectedQuestionById" [subjectById]="subjectById"></app-questionstatus-history>

        </div>
      </div>
    </div>
  </div>
